import { EVENT_DETAILS_FIELD, EVENT_SOURCE_FIELD, EVENT_TARGET_FIELD } from 'schemas/constants';
import { DEFAULT_FIELDS } from 'schemas/default-fields';
import { DATASOURCE, FIELD_TYPE, Schema } from 'schemas/types';

export const schema: Schema = {
  dataSource: DATASOURCE.OKTA,
  dataSourceId: 'Okta',
  dataSourceVendor: 'Okta',
  dataSourceLabel: 'Okta',
  fields: {
    ...DEFAULT_FIELDS,
    [EVENT_SOURCE_FIELD]: {
      label: 'Event Source',
      type: FIELD_TYPE.EVENT_SOURCE,
      notSearchable: true,
      relatedFields: ['actor.alternateId'],
      width: 540, // (160 + 20) x 3
    },
    [EVENT_TARGET_FIELD]: {
      label: 'Event Target',
      type: FIELD_TYPE.EVENT_TARGET,
      notSearchable: true,
      relatedFields: ['tgt.displayName', 'tgt.alternateId'],
      width: 540, // (160 + 20) x 3
    },
    [EVENT_DETAILS_FIELD]: {
      label: 'Event Details',
      type: FIELD_TYPE.EVENT_DETAILS,
      notSearchable: true,
      description: 'Event additional details',
      width: 900,
      relatedFieldsMap: { identity: ['event.outcome.result', 'event.outcome.reason', 'event.externalThreatValue'] },
    },
    'actor.alternateId': {
      label: 'Actor',
      type: FIELD_TYPE.USER,
    },
    'actor.displayName': {
      label: 'Actor Display Name',
      type: FIELD_TYPE.USER,
    },
    'actor.id': {
      label: 'Actor ID',
      type: FIELD_TYPE.ID,
    },
    'event.externalId': {
      label: 'Event external ID',
      type: FIELD_TYPE.ID,
    },
    'event.externalThreatValue': {
      label: 'Event external threat value',
      type: FIELD_TYPE.TEXT,
    },
    'event.login.accountName': {
      label: 'Event login account name',
      type: FIELD_TYPE.USER,
    },
    'event.outcome.result': {
      label: 'Event Outcome Result',
      type: FIELD_TYPE.TEXT,
    },
    'event.outcome.reason': {
      label: 'Event Outcome Reason',
      type: FIELD_TYPE.TEXT,
    },
    'tgt.displayName': {
      label: 'Target Display Name',
      type: FIELD_TYPE.TEXT,
    },
    'tgt.alternateId': {
      label: 'Target alternate ID',
      type: FIELD_TYPE.TEXT,
    },
  },
  summaryFieldIds: ['actor.alternateId', 'actor.displayName', 'event.login.accountName'],
};
